import React, { useEffect } from 'react';
import { Frame, FrameTwo } from '../Frame';
import Aos from 'aos';
import { Popover, PopoverContent, PopoverTrigger } from '../ui/popover';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../ui/accordion';
import coverSea from '../../images/Antoine_Meyssonnier--5.jpg';
import waterGlass from '../../images/glass.png';

const WaterResult = () => {
  useEffect(() => {
    Aos.init();
  }, []);
  return (
    <>
      <div className="container mx-auto mt-20 md:px-40 sm:px-40 ">
        <div className="font-bold">Resultat qualité de l’eau</div>
        <p className="mt-2 text-justify">
          Depuis près de 4 milliards d’années, la même eau circule entre ciel et terre. Au cours de
          son parcours, elle se transforme et se retrouve dans l’air, dans les cours d’eau, sous
          terre, dans les glaciers et les océans. C’est le grand cycle de l’eau avec l’énergie
          solaire pour moteur. Pour renouveler les stocks d’eau douce, chaque étape est importante :
        </p>

        <div className="flex justify-center m-10 ">
          <div className="flex flex-col justify-center  gap-[53px]">
            <div className="lg:flex justify-center items-center gap-[17px] relative ">
              <div
                className="items-start gap-[10px] p-[10px] inline-flex flex-col relative flex-[0_0_auto] "
                data-aos="fade-right"
              >
                <Popover>
                  <PopoverTrigger asChild>
                    <div className="flex cursor-pointer ">
                      <Frame
                        data-aos="fade-right"
                        className="!flex-[0_0_auto]"
                        text="Turbidité"
                        text1="NFU"
                        valeur="0.12 NFU"
                        norme="1"
                      />
                    </div>
                  </PopoverTrigger>
                  <PopoverContent className="scale-110 w-52 md:w-80">
                    <span className="font-bold text-primary">La Turbidité</span> de l’eau a pour
                    origine la présence de matières en suspension (argile, limons, particules
                    organiques colloïdales, plancton, organismes microscopiques) qui donnent un
                    aspect trouble à l’eau.
                  </PopoverContent>
                </Popover>

                <Popover>
                  <PopoverTrigger asChild>
                    <div className="cursor-pointer ">
                      <Frame
                        className="!flex-[0_0_auto]"
                        text="pH"
                        text1="UpH"
                        valeur="7.9 UpH"
                        norme="5.6 à 9 **"
                      />
                    </div>
                  </PopoverTrigger>
                  <PopoverContent className="scale-110 w-52 md:w-96">
                    <span className="font-bold text-primary ">Le pH</span> abréviation de “potentiel
                    Hydrogène” est un indice qui traduit la concentration d’ions Hydrogènes dans une
                    solution. Il détermine l’acidité, l’alcalinité ou la neutralité de l’eau.
                    L’échelle qui sert à le mesurer est comprise entre 0 et 14. Une eau dont le pH
                    est inférieur à 7 est dite acide. Lorsque son pH est supérieur à 7, on dit
                    qu’elle est basique (alcaline) et s’il est égal à 7, l’eau est dite neutre. Le
                    pH d’une eau est directement lié à son origine et à la nature des terrains
                    qu’elle traverse. Suivant sa valeur, il est parfois nécessaire de le
                    rééquilibrer car le pH de l’eau peut avoir de nombreuses incidences sur d’autres
                    paramètres.
                  </PopoverContent>
                </Popover>

                <Popover>
                  <PopoverTrigger asChild>
                    <div className="cursor-pointer ">
                      <Frame
                        data-aos="fade-right"
                        className="!flex-[0_0_auto]"
                        text="Dureté"
                        text1="TH"
                        valeur="19 °F"
                        norme="-"
                      />
                    </div>
                  </PopoverTrigger>
                  <PopoverContent className="w-52 md:w-96">
                    <span className="font-bold text-primary ">La dureté</span> d’une eau ou son
                    titre hydrotimétrique (TH) exprime sa concentration en sels de calcium et de
                    magnésium. Comme le pH, la dureté est liée à la nature des terrains traversés
                    par une eau. Si l’eau présente une forte concentration de ces sels minéraux, on
                    dit qu’elle est dure (c’est le cas des eaux provenant des sois calcaires). A
                    l’inverse, si cette concentration est faible, l’eau est dite douce, ce qui est
                    le cas par exemple en Bretagne lorsqu’elle provient ou traverse des sols
                    granitiques. Une eau dure, par son apport en calcium et en magnésium, est bonne
                    pour la santé, mais elle accélère par contre l’entartrage des conduites et
                    réagit mal au savon. A l’inverse, une eau trop douce a tendance à corroder les
                    canalisations.
                  </PopoverContent>
                </Popover>
              </div>
              <div className=" lg:flex items-center gap-[106px] relative flex-[0_0_auto]">
                <img
                  data-aos="zoom-in"
                  className="relative w-[145px] md:w-[345px] md:h-[568px] object-cover"
                  alt="Element water glass"
                  src={waterGlass}
                />
                <div
                  className="items-start gap-[10px] p-[10px] inline-flex flex-col relative flex-[0_0_auto]"
                  data-aos="fade-left"
                >
                  <Popover>
                    <PopoverTrigger asChild>
                      <div className="cursor-pointer ">
                        <Frame
                          className="!flex-[0_0_auto]"
                          text="Magnésium"
                          text1="Mg"
                          valeur="8.5 mg/1"
                          norme="-"
                        />
                      </div>
                    </PopoverTrigger>
                    <PopoverContent className="w-52 md:w-96">
                      <span className="font-bold text-primary ">Le magnésium</span> est un élément
                      très répandu dans la nature, dans de nombreux minéraux et dans les calcaires
                      (2,1 % de l’écorce terrestre). Son abondance géologique, sa grande solubilité,
                      sa large utilisation industrielle font que les teneurs dans l’eau peuvent être
                      importantes (quelques mg/l à plusieurs centaines de mg/l). La plupart des eaux
                      naturelles présentent des teneurs comprises entre 5 et 10 mg/l. Cette
                      concentration est en relation directe avec la nature géologique des terrains
                      traversés. Le magnésium dans l’eau provient de l’attaque par l’acide
                      carbonique des roches magnésiennes et de la mise en solution de magnésium sous
                      forme de carbonates (MgCO3) et de bicarbonates (Mg2HCO3).
                    </PopoverContent>
                  </Popover>

                  <Popover>
                    <PopoverTrigger asChild>
                      <div className="cursor-pointer ">
                        <Frame
                          className="!flex-[0_0_auto]"
                          text="Calcium"
                          text1="Ca"
                          valeur="61 mg/1"
                          norme="-"
                        />
                      </div>
                    </PopoverTrigger>
                    <PopoverContent className="w-52 md:w-96">
                      <span className="font-bold text-primary ">Le calcium</span> est un métal
                      alcalino-terreux extrêmement répandu dans la nature et en particulier dans les
                      roches calcaires, sous forme de carbonates. Ces sels se rencontrent dans
                      presque toutes les eaux naturelles. Leur teneur dans l’eau, qui peut varier de
                      1 à 150 mg/l, est directement liée à la nature géologique des terrains
                      traversés. Les sels de calcium sont obtenus en majorité lors de l’attaque de
                      roches calcaires par l’anhydride carbonique dissous (CO2). Il constitue
                      l’élément cationique dominant des eaux superficielles. Le calcium est
                      l’élément principal de la dureté de l’eau.
                    </PopoverContent>
                  </Popover>

                  <Popover>
                    <PopoverTrigger asChild>
                      <div className="cursor-pointer ">
                        <Frame
                          className="!flex-[0_0_auto]"
                          text="Chlorure"
                          text1="Cl"
                          valeur="32.0 mg/1"
                          norme="250 **"
                        />
                      </div>
                    </PopoverTrigger>
                    <PopoverContent className="w-52 md:w-96">
                      <span className="font-bold text-primary ">Les chlorures</span> très répandus
                      dans la nature, généralement sous forme de sels de sodium (NaCI), de potassium
                      (KCI) et de calcium (CaCl2), les ions chlorures (Cl-) dont la plus grande
                      partie se trouve dans les océans, constituent environ 0,05 % de la lithosphère
                      (partie solide de la sphère terrestre). De façon générale, l’ion chlorure est
                      présent dans toutes les eaux, à des concentrations variables. Dans les eaux de
                      surface, il est présent en faible concentration. Dans les eaux souterraines,
                      la teneur en ion chlorure peut atteindre quelques grammes par litre au contact
                      de certaines formations géologiques.
                    </PopoverContent>
                  </Popover>
                </div>
              </div>
            </div>
            <div className="relative items-center justify-center lg:flex " data-aos="fade-up">
              <Popover>
                <PopoverTrigger asChild>
                  <div className="cursor-pointer ">
                    <FrameTwo text="Sulfates" text1="SO₄²-" valeur="89.8 mg/1" norme="250 **" />
                  </div>
                </PopoverTrigger>
                <PopoverContent className="w-52 md:w-96">
                  <span className="font-bold text-primary ">Les sulfates</span> composés naturels
                  des eaux, les ions sulfates (SO4–) sont liés aux cations majeurs : calcium,
                  magnésium et sodium. A part ceux du plomb, du baryum et du strontium, la plupart
                  des sulfates sont solubles dans l’eau. Ils peuvent néanmoins être réduits en
                  sulfure, volatilisés dans l’air en hydrogène sulfure (H2S), précipités en sel
                  insoluble ou assimilés par des organismes vivants. La concentration en sulfates
                  dans les eaux naturelles est très variable, mais ne dépasse généralement pas le
                  gramme par litre.
                </PopoverContent>
              </Popover>

              <Popover>
                <PopoverTrigger asChild>
                  <div className="cursor-pointer ">
                    <FrameTwo text="Nitriles" text1="NO2–" valeur="< 0.02 mg/1" norme="0.1" />
                  </div>
                </PopoverTrigger>
                <PopoverContent className="w-52 md:w-96">
                  <span className="font-bold text-primary ">Les nitriles</span> (NO2–), comme les
                  nitrates, sont présents à l’état naturel dans les sols, les eaux et les plantes,
                  mais généralement en faible quantité. Plus une eau est riche en nitrates, plus le
                  risque est important pour l’homme de consommer des nitrites, car les nitrates se
                  transforment en nitrites dans notre estomac par le phénomène chimique de la
                  réduction (élimination d’oxygène). Une trop forte concentration de nitrites dans
                  l’organisme peut provoquer des maladies graves (des cyanoses notamment), en
                  particulier chez les nourrissons dont l’alimentation est constituée
                  essentiellement de lait réhydraté. La consommation d’eaux trop riches en nitrates
                  est, pour les mêmes raisons, fortement déconseillée aux femmes enceintes.
                </PopoverContent>
              </Popover>

              <Popover>
                <PopoverTrigger asChild>
                  <div className="cursor-pointer ">
                    <FrameTwo text="Nitrates" text1="NO3–" valeur="15.2 mg/1" norme="50" />
                  </div>
                </PopoverTrigger>
                <PopoverContent className="w-52 md:w-96">
                  <span className="font-bold text-primary ">Les nitrates</span> (NO3–) résultent de
                  l’oxydation de l’azote organique et sont donc présents à l’état naturel dans les
                  sols et dans les eaux. L’augmentation du taux de nitrates dans les eaux
                  superficielles et souterraines est due pour une large part à l’enrichissement des
                  sols par des engrais chimiques ou organiques, ainsi qu’aux rejets d’eaux usées ou
                  mal traitées dans les cours d’eau. Les nitrates en eux-mêmes ne présentent pas de
                  danger particulier pour la santé, c’est leur transformation en nitrites dans
                  l’estomac qui peut être toxique.
                </PopoverContent>
              </Popover>

              <Popover>
                <PopoverTrigger asChild>
                  <div className="cursor-pointer ">
                    <FrameTwo text="Ammonium" text1="NH4" valeur="< 0.05 mg/1" norme="0.1 **" />
                  </div>
                </PopoverTrigger>
                <PopoverContent className="w-52 md:w-96">
                  <span className="font-bold text-primary ">L’ammoniaque</span> Sont désignées sous
                  le terme ammoniaque des formes ionisées (ion ammonium NH4) et non ionisées (NH3)
                  de l’azote ammoniacal. La présence d’azote ammoniacal dans l’eau, comme celle des
                  nitrates, provient de la décomposition des déchets végétaux et animaux. Sous sa
                  forme ionisée, l’azote ammoniacal est peu toxique, mais une forte concentration
                  dans l’eau peut être le signe d’une pollution par des matières fécales ou par des
                  rejets industriels.
                </PopoverContent>
              </Popover>
            </div>
          </div>
        </div>

        <div className="mt-20 ">
          <Accordion type="single" collapsible className="w-full">
            <AccordionItem value="item-1">
              <AccordionTrigger className="font-bold text-black">
                Comment définit-on un bon état des eaux ?
              </AccordionTrigger>
              <AccordionContent>
                Une eau en bon état se définit par une qualité et une quantité d’eau suffisante pour
                assurer l’équilibre écologique du milieu aquatique, répondre à la demande en eau et
                maintenir la santé humaine. Depuis 2000, la Directive Cadre Européenne sur l’Eau
                définit les règles d’évaluation des conditions de l’eau. Elle oblige les États
                membres à atteindre de bonnes conditions d’eau tout en réduisant ou en éliminant les
                émissions de certaines substances. L’ensemble de ces objectifs est décrit dans le{' '}
                <a
                  href="https://www.eau-seine-normandie.fr/domaines-d-action/sdage"
                  className="font-bold text-primary"
                  target="_blank"
                  rel="noreferrer"
                >
                  SDAGE du Bassin de la Seine.
                </a>
              </AccordionContent>
            </AccordionItem>
            <AccordionItem value="item-2">
              <AccordionTrigger className="font-bold text-black">
                Qu’en est-il des perturbateurs endocriniens ?
              </AccordionTrigger>
              <AccordionContent>
                La définition des perturbateurs endocriniens fait encore aujourd’hui l’objet de
                débats au niveau international. Cependant, celle qui a été proposée par
                l’Organisation mondiale de la santé en 2002 est la plus communément admise : <br />{' '}
                <br /> « Un perturbateur endocrinien (PE) désigne une substance ou un mélange qui
                altère les fonctions du système endocrinien et de ce fait induit des effets néfastes
                dans un organisme intact, chez sa progéniture ou au sein de (sous)-populations ».{' '}
                <br /> <br /> Dans les mesures de qualité de l’eau potable ils sont classés dans les
                « pesticides et produits apparentés ». Les concentrations en jeu sont de l’ordre du
                microgramme par litre dans les milieux aquatiques, voire moins. En fonction de leurs
                caractéristiques physico-chimiques et de leurs sources d’émission, on les trouve
                préférentiellement dans l’eau, dans les sédiments, dans les organismes vivants,
                relargués vers l’atmosphère, stockés dans les sols. <br /> <br />
                Selon une décision adoptée par la Commission européenne le 19 janvier, la présence
                potentielle de deux perturbateurs endocriniens (bêta-estradiol et nonylphénol) doit
                être surveillée tout au long de la chaîne d’approvisionnement en eau potable.
              </AccordionContent>
            </AccordionItem>
            <AccordionItem value="item-3">
              <AccordionTrigger className="font-bold text-black">
                Aquavesc : la qualité de l’eau est une priorité ?
              </AccordionTrigger>
              <AccordionContent>
                Afin de garantir une excellente qualité de l’eau, nous effectuons des relevés
                analytiques plusieurs fois par semaine par plusieurs ingénieurs eaux potables de
                chez Suez qui se chargent de la qualité ainsi que des personnes spécialisées en
                évaluation des risques sanitaires et à l’eau potable. <br /> <br />
                Leur travail consiste à identifier les différentes molécules de l’eau afin de
                s’assurer qu’elles ne présentent aucun risque sanitaire. Ces relevés se font à
                différents endroits comme à l’entrée et à la sortie du site de Louveciennes dans des
                forages représentatifs. Ces différents relevés sont sous la hiérarchie de directives
                européennes ainsi que de l’
                <a
                  href="https://www.anses.fr/fr/content/acc%C3%A9l%C3%A9rer-l%E2%80%99%C3%A9valuation-des-perturbateurs-endocriniens"
                  className="font-bold text-primary"
                  target="_blank"
                  rel="noreferrer"
                >
                  ANSES
                </a>{' '}
                (L’Agence Nationale de Sécurité Sanitaire Française).
              </AccordionContent>
            </AccordionItem>
          </Accordion>
        </div>

        <section
          className="p-32 mt-5 mb-10 text-center bg-blue-100 "
          style={{
            backgroundImage: `url(${coverSea})`,
            backgroundSize: 'cover',
          }}
        ></section>
      </div>
    </>
  );
};

export default WaterResult;
